module.exports = __webpack_public_path__ + "media/images/logo-tastee-2ce39cf067f56a23ecd086ffc53535dd.png";